import { parseTweet } from 'twitter-text';

function getExtension(filename) {
  var parts = filename.split('.');
  return parts[parts.length - 1];
}
function isVideo(filename) {
  var ext = getExtension(filename);
  switch (ext.toLowerCase()) {
    case 'm4v':
    case 'avi':
    case 'mpg':
    case 'mp4':
      // etc
      return true;
  }
  return false;
}
export default {
  _validate(platform, post) {
    switch (platform) {
      case 'facebook':
        return this._validateFacebook(post);
      case 'instagram':
        return this._validateInstagram(post);
      case 'twitter':
        return this._validateTwitter(post);
      case 'linkedin':
        return this._validateLinkedIn(post);
    }
  },
  _validateInstagram(post) {
    const platform = 'instagram';
    return new Promise((resolve, reject) => {
      if (post.media.type !== 'image' && post.media.type !== 'video') {
        resolve(
          this._error(
            platform,
            'Voeg media toe om de post te kunnen plaatsen op Instagram.'
          )
        );
      } else if (isVideo(post.media.url)) {
        this._getVideoLength(post.file).then(duration => {
          if (duration > 60) {
            resolve(this._error(platform, 'MAX duratie van 60 seconden.'));
          } else {
            resolve(this._success(platform));
          }
        });
      } else if (this._hasUrl(post.content)) {
        resolve(this._warning(platform, 'Links worden niet getoond als links'));
      } else {
        resolve(this._success(platform));
      }
    });
  },
  _validateLinkedIn(post) {
    const platform = 'linkedin';
    return new Promise((resolve, reject) => {
      if (
        typeof post.text === 'undefined' ||
        (typeof post.text !== 'undefined' && post.text.length === 0)
      ) {
        resolve(this._error(platform, 'Voer een tekst in.'));
      } else if (typeof post.text !== 'undefined' && post.text.length > 1300) {
        resolve(
          this._error(platform, 'Tekst mag niet langer zijn dan 1300 tekens')
        );
      } else if (this._hasUrl(post.text)) {
        resolve(
          this._warning(
            platform,
            'Een link moet altijd opgevolgd worden met een teken, zoals een .'
          )
        );
      } else {
        resolve(this._success(platform));
      }
    });
  },
  _validateTwitter(post) {
    const platform = 'twitter';
    return new Promise((resolve, reject) => {
      if (typeof post.text === 'undefined' || post.text === '') {
        resolve(
          this._error(platform, 'MAX 280 tekens (hierin zijn urls uitgesloten)')
        );
      } else if (parseTweet(post.text).weightedLength > 280) {
        resolve(
          this._error(platform, 'MAX 280 tekens (hierin zijn urls uitgesloten)')
        );
      } else if (typeof post.file !== 'undefined') {
        if (post.file.size > 3000000) {
          resolve(this._error(platform, 'The image cannot be larger then 3MB'));
        } else if (isVideo(post.file.name)) {
          this._getVideoLength(post.file).then(duration => {
            if (duration > 140) {
              resolve(this._error(platform, 'MAX duratie van 140 seconden.'));
            } else {
              resolve(this._success(platform));
            }
          });
        } else {
          resolve(this._success(platform));
        }
      } else {
        resolve(this._success(platform));
      }
    });
  },
  _validateFacebook(post) {
    const platform = 'facebook';
    return new Promise((resolve, reject) => {
      if (
        !this._hasUrl(post.text) &&
        post.media.type !== 'image' &&
        post.media.type !== 'video'
      ) {
        resolve(
          this._error(
            platform,
            'De post moet een link of een media bestand hebben.'
          )
        );
      } else {
        resolve(this._success(platform));
      }
    });
  },
  _getVideoLength({ commit }, videoFile) {
    return new Promise((resolve, reject) => {
      if (typeof videoFile !== 'undefined' && this.isVideo(videoFile.name)) {
        console.log(videoFile);
        let video = document.createElement('video');
        video.preload = 'metadata';

        video.onloadedmetadata = function() {
          window.URL.revokeObjectURL(video.src);
          resolve(video.duration);
        };
        video.src = URL.createObjectURL(videoFile);
      }
    });
  },
  _hasUrl(string) {
    return new RegExp(
      '([a-zA-Z0-9]+://)?([a-zA-Z0-9_]+:[a-zA-Z0-9_]+@)?([a-zA-Z0-9.-]+\\.[A-Za-z]{2,4})(:[0-9]+)?(/.*)?'
    ).test(string);
  },
  _warning(platform, msg) {
    return {
      platform: platform,
      state: {
        msg: msg,
        status: 'warning'
      }
    };
  },
  _error(platform, msg) {
    return {
      platform: platform,
      state: {
        msg: msg,
        status: 'danger'
      }
    };
  },
  _success(platform, msg = false) {
    if (!msg) {
      msg = 'This post is valid';
    }
    return {
      platform: platform,
      state: {
        msg: msg,
        status: 'good'
      }
    };
  }
};
